import React from 'react';
import classNames from 'classnames';
import Flag from '../../../flag';
import Paragraph from '../../../paragraph';
const TagContent = (props) => {
  const {
    selectProps: { isDisabled, isTagTextClipped },
    children,
    data: { flag } = {},
  } = props;

  const classes = classNames('ws-ui-base-select-tag-content', {
    'ws-ui-base-select-tag-content--is-disabled': isDisabled,
  });
  return (
    <div className={classes}>
      {!!flag?.code && (
        <div className="ws-ui-base-select-tag-content__flag">
          <Flag size="20px" {...flag} />
        </div>
      )}
      <Paragraph
        isClipped={isTagTextClipped}
        size="small"
        {...(isDisabled && { appearance: 'low-emphasis' })}
      >
        {children}
      </Paragraph>
    </div>
  );
};

export default TagContent;
